module.exports = __webpack_public_path__ + "static/media/user.dc1fa075.svg";